/* eslint-disable react/style-prop-object */
import { Link, useHistory } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";

import Template from "../../template/template";
import Header from "./header/header";
import Common from "./commons/commons";
import { Breadcrumb } from "../../components/breadcrumb";
import { useCallback, useRef } from "react";

function Support() {
  initPage({ title: "" });
  const inputSearchRef = useRef(null);
  const history = useHistory();

  const handleSearch = useCallback(() => {
    const searchValue = inputSearchRef.current.value;

    history.push(DefRoutes.Search, searchValue);
  }, [history]);

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="support-warp">
              <div className="support-warp-main">
                <Header />

                <div className="support-content">
                  <div className="support-search">
                    <h4>{t("Support.Search")}</h4>
                    <div className="input-text icon-search" onClick={handleSearch}>
                      <form
                        onSubmit={(event) => {
                          event.preventDefault();
                          handleSearch();
                        }}
                      >
                        <input ref={inputSearchRef} type="text" onClick={(event) => event.stopPropagation()} />
                      </form>
                    </div>
                  </div>

                  <Common />

                  <div className="team-help-warp">
                    <h3>{t("Support.Theme")}</h3>
                    <ul className="teram-help-list">
                      <li>
                        <div className="team-box">
                          <Link to={DefRoutes.Themes.replace(":theme", "Account")} className="link-cover"></Link>
                          <img src="/images/card-tema1.png" alt="" />
                          <div className="over-caption">
                            <div className="cp-inner">
                              <div className="icon-media">
                                <img src="/images/tema-assuntos-ico1.png" alt="" />
                              </div>
                              <h4 className="text-uppercase">{t("Support.Themes.Account")}</h4>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="team-box">
                          <Link to={DefRoutes.Themes.replace(":theme", "Technical")} className="link-cover"></Link>
                          <img src="/images/card-tema2.png" alt="" />
                          <div className="over-caption">
                            <div className="cp-inner">
                              <div className="icon-media">
                                <img src="/images/tema-assuntos-ico2.png" alt="" />
                              </div>
                              <h4 className="text-uppercase">{t("Support.Themes.Technical")}</h4>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="team-box">
                          <Link to={DefRoutes.Themes.replace(":theme", "Payment")} className="link-cover"></Link>
                          <img src="/images/card-tema3.png" alt="" />
                          <div className="over-caption">
                            <div className="cp-inner">
                              <div className="icon-media">
                                <img src="/images/tema-assuntos-ico3.png" alt="" />
                              </div>
                              <h4 className="text-uppercase">{t("Support.Themes.Payment")}</h4>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="team-box">
                          <Link to={DefRoutes.Themes.replace(":theme", "Others")} className="link-cover"></Link>
                          <img src="/images/card-tema4.png" alt="" />
                          <div className="over-caption">
                            <div className="cp-inner">
                              <div className="icon-media">
                                <img src="/images/tema-assuntos-ico4.png" alt="" />
                              </div>
                              <h4 className="text-uppercase">{t("Support.Themes.Others")}</h4>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Support;
